// Angular
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Component Library
import { FsxOption } from 'fsx-component-library';


/** Custom validator to check if the label is a duplicate. */
export function duplicateLabelValidator<T>(options: FsxOption<T>[], selectedOption: FormControl<string | FsxOption<T>>): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    // Make sure the control has a value and it is a string
    if (!control.value || typeof control.value !== 'string') {
      return null;
    }

    const controlValue = control.value.trim().toLowerCase();
    const selectedValue = typeof selectedOption.value === 'string'
      ? selectedOption.value
      : selectedOption.value?.label;
    const caseInsensitiveSelectedValue = selectedValue?.trim().toLowerCase();

    // If the control value matches the selected option's value, return null
    if (controlValue === caseInsensitiveSelectedValue) {
      return null;
    }

    // Check if the value is a duplicate of any of the options
    if (options.some(option => option.label.trim().toLowerCase() === controlValue)) {
      return { duplicateLabel: true };
    }

    return null;
  };
}


/** Custom validator to apply minLength validation on non-required inputs **/
export function minLengthValidator(min: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    if (value && (value.length < min || value === "")) {
      // Trigger minLength error for values shorter than the required length
      return { minLength: true };
    }
    // No errors
    return null;
  };
}

export const CASE_PHONE_NUMBER_REGEX = `^(?:\\+1\\s?)?(?:\\(?\\d{3}\\)?[\\s.-]?)?\\d{3}[\\s.-]?\\d{4}$`;
export const CASE_NAME_REGEX = `^[a-zA-Z\\s'-]*$`;
export const CASE_ADDRESS_REGEX = `^[a-zA-Z0-9\\s'.\\-]*$`;
/**
 * Regex pattern for a valid SSN or TIN.
 */
export const CASE_SSN_AND_TIN_REGEX = `^(?:(?!000|666|9\\d{2})\\d{3}[-\\s]?(?!00)\\d{2}[-\\s]?(?!0000)\\d{4}|(?!00)\\d{2}[-\\s]?\\d{7})$`
